module.exports = __webpack_public_path__ + "img/computer-speaker.8987ac07.svg";